export enum DoAnyApplyOption {
  OVERWEIGHT = "OVERWEIGHT",
  OBESITY = "OBESITY",
  DIABETES = "DIABETES",
  METABOLIC_SYNDROME = "METABOLIC_SYNDROME",
  HIGH_CHOLESTEROL = "HIGH_CHOLESTEROL",
  PCOS = "PCOS",
  FATTY_LIVER_DISEASE = "FATTY_LIVER_DISEASE",
  LIPODYSTROPHY = "LIPODYSTROPHY",
  OVER_40 = "OVER_40",
  TWO_LOSSES = "TWO_LOSSES",
  URGENT_MEDICAL_NEED = "URGENT_MEDICAL_NEED",
  NEVER_MENSTRUATED = "NEVER_MENSTRUATED",
  FAMILY_BLOOD_CLOTTING = "FAMILY_BLOOD_CLOTTING",
  NONE = "NONE"
}

export enum RespondedToSprintsScreener {
  YES = "YES"
}
